//@flow

import produce from 'immer';
import {
    appointmentSituationReducerType,
    appointmentSituationActionType,
} from './AppointmentSituationTypes';
import {
    SET_APPOINTMENT_SITUATION_ARE_YOU_CLIENT,
    SET_APPOINTMENT_SITUATION_FIRSTNAME,
    SET_APPOINTMENT_SITUATION_NAME,
    SET_APPOINTMENT_SITUATION_EMAIL,
    SET_APPOINTMENT_SITUATION_PHONE_NUMBER,
    SET_APPOINTMENT_SITUATION_BIRTHDATE,
    SET_APPOINTMENT_SITUATION_CONTACT_LANGUAGE,
    SET_APPOINTMENT_SITUATION_YOUR_JOB,
    SET_APPOINTMENT_SITUATION_YOUR_EMPLOYER,
    SET_APPOINTMENT_SITUATION_HAVE_SALES_AGREEMENT,
    SET_APPOINTMENT_SITUATION_WANT_INSURANCE,
    SET_APPOINTMENT_SITUATION_MORE_INFOS,
    SET_APPOINTMENT_SITUATION_SHOULD_WE_USE_YOUR_DATA,
    SET_APPOINTMENT_SITUATION_SELECTED_AGENCY,
    SET_APPOINTMENT_SITUATION_SELECTED_SIMULATION,
    SET_APPOINTMENT_SITUATION_HAS_PURCHASE_ORDER,
    SET_APPOINTMENT_SITUATION_CURRENT_STEP, SET_APPOINTMENT_TYPE,
} from '../../resources/constants/storeActions';
import {areaCode} from '../../resources/constants/areaCodes';

const initialState: appointmentSituationReducerType = {
    areYouClient: null,
    firstname: null,
    name: null,
    birthdate: null,
    email: null,
    phoneNumber: areaCode['LU'],
    contactLanguage: null,
    yourJob: null,
    yourEmployer: null,
    haveSalesAgreement: null,
    wantInsurance: null,
    moreInfos: null,
    shouldWeUseYourData: null,
    selectedAgency: null,
    selectedSimulation: 0,
    hasPurchaseOrder: null,
    currentStep: 1
};

const appointmentSituationReducer = (
    state: appointmentSituationReducerType = initialState,
    action: appointmentSituationActionType,
) =>
    produce(state, (draft: appointmentSituationReducerType) => {
        switch (action.type) {
            case SET_APPOINTMENT_SITUATION_ARE_YOU_CLIENT:
                draft.areYouClient = action.payload.areYouClient;
                break;

            case SET_APPOINTMENT_SITUATION_FIRSTNAME:
                draft.firstname = action.payload.firstname;
                break;

            case SET_APPOINTMENT_SITUATION_NAME:
                draft.name = action.payload.name;
                break;

            case SET_APPOINTMENT_SITUATION_BIRTHDATE:
                draft.birthdate = action.payload.birthdate;
                break;

            case SET_APPOINTMENT_SITUATION_EMAIL:
                draft.email = action.payload.email;
                break;

            case SET_APPOINTMENT_SITUATION_PHONE_NUMBER:
                draft.phoneNumber = action.payload.phoneNumber;
                break;

            case SET_APPOINTMENT_SITUATION_CONTACT_LANGUAGE:
                draft.contactLanguage = action.payload.contactLanguage;
                break;

            case SET_APPOINTMENT_SITUATION_YOUR_JOB:
                draft.yourJob = action.payload.yourJob;
                break;

            case SET_APPOINTMENT_SITUATION_YOUR_EMPLOYER:
                draft.yourEmployer = action.payload.yourEmployer;
                break;

            case SET_APPOINTMENT_SITUATION_HAVE_SALES_AGREEMENT:
                draft.haveSalesAgreement = action.payload.haveSalesAgreement;
                break;

            case SET_APPOINTMENT_SITUATION_WANT_INSURANCE:
                draft.wantInsurance = action.payload.wantInsurance;
                break;

            case SET_APPOINTMENT_SITUATION_MORE_INFOS:
                draft.moreInfos = action.payload.moreInfos;
                break;

            case SET_APPOINTMENT_SITUATION_SHOULD_WE_USE_YOUR_DATA:
                draft.shouldWeUseYourData = action.payload.shouldWeUseYourData;
                break;

            case SET_APPOINTMENT_SITUATION_SELECTED_AGENCY:
                draft.selectedAgency = action.payload.selectedAgency;
                break;

            case SET_APPOINTMENT_SITUATION_SELECTED_SIMULATION:
                draft.selectedSimulation = action.payload.selectedSimulation;
                break;

            case SET_APPOINTMENT_SITUATION_HAS_PURCHASE_ORDER:
                draft.hasPurchaseOrder = action.payload.hasPurchaseOrder;
                break;

            case SET_APPOINTMENT_SITUATION_CURRENT_STEP:
                draft.currentStep = action.payload.currentStep;
                break;
            case SET_APPOINTMENT_TYPE:
                draft.appointmentType = action.payload.appointmentType;
                break;
            default:
                break;
        }
    });

export default appointmentSituationReducer;
